// extracted by mini-css-extract-plugin
export default {"form":"FormCatCard_form__prddd","select":"FormCatCard_select__V4rXJ","button":"FormCatCard_button__n1tGj"};